import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M19 7h-8v6h8V7zm-2 4h-4V9h4v2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 9h4v2h-4z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"
})), 'PictureInPictureTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PictureInPictureTwoTone.js
// module id = 5480
// module chunks = 2